import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import App from './Component/App';
import { change } from 'redux-form';
import Phi from './../../Phi/Phi';


const mapStateToProps = (state, ownProps) => {

    const userRole = Phi.User.roles();

    return {
        isAuthenticated: state.auth.isAuthenticated,
        message: state.auth.message,
        isLoading: state.auth.isLoading,
        currentProgram: state.organization.currentProgram,
        history: state.organization.history,
        studentHeader: state.student.studentHeader,
        startNodeMap: state.organization.startNodeMap,
        roleType: userRole && userRole.length && userRole[0].role_type_id
    }
};


const mapDispatchToProps = (dispatch) => ({
    loginResponse: (response) => {
        dispatch(Actions.loginResponse(response))
    },
    fetchStudentList: payload => dispatch(Actions.fetchStudentList(payload)),
    getReport: (reportType, config) => dispatch(Actions.getReport(reportType, config)),
    changeFieldValue: (field, value) => dispatch(change('customForm', field, value)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    changePassword: newPassword => dispatch(Actions.changePassword(newPassword)),
    changeReportInReducer: (billingId) => dispatch(Actions.changeReportInReducer(billingId)),
    logoutUser: () => dispatch(Actions.logoutUser()) // Action to logout

});


export default connect(mapStateToProps, mapDispatchToProps)(App)